import { createClient } from '@sanity/client'
import ImageUrlBuilder from "@sanity/image-url";

export const client = createClient({
    projectId: 'g1ssbo0g',
    dataset: 'production',
    apiVersion: '2023-03-16',
    useCdn: true,
    // token: 'sksPiU7CBTlIudrFlCcWZqwMW0LBDsa6Jqc0YobOMM0UqBHCTnRxmSZ07VGVL7isbUmoEU6WFcwbkTCQKiXyZ9H21nEh0LvdksCHmbItnSyGnWtIudjJhZoInxQjs8dkrbCCuGU1zrrGqdiznKxhBEwzqoWZeK4GavBkUODqR4Mhm4vBHAD2',
    token: process.env.SANITY_PROJECT_KEY,
})

const builder = ImageUrlBuilder(client);
export const urlFor = (source) => builder.image(source); 
